import * as React from "react"
import { Widget, mk_widget, any } from "widgets-for-react"
import { styleguideChapter, styleguideSection, styleguidePart, styleguideExample } from "../helpers"

export const styleguideObjects: Widget<never> = mk_widget({
  run: _ => (
    styleguideChapter({ type: 'objects', slug: 'objects', title: 'Design Objects', intro: 'If design tokens are the atoms of the design system, design objects are the material — specifically, they what comes after. We use them to make the developer’s job easier and to give the designers some extra insight in their work.'})(
      any()([
        styleguideSection({ type: 'objects', slug: 'objects-links', title: 'Links', intro: ''})(
          any()([
            styleguidePart({ title: 'Inline link', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <div className="text--styled">
                      <p>Integer posuere erat a ante venenatis <a href="#">Donec ullamcorper nulla</a> aliquet. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Donec id elit non mi porta gravida at eget metus.</p>
                    </div>
                  )
                })
              )
            )
          ])
        ),
        styleguideSection({ type: 'objects', slug: 'objects-buttons', title: 'Buttons', intro: ''})(
          any()([
            styleguidePart({ title: 'Button primary', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <button className="button--primary">Button primary</button>
                  )
                })
              )
            ),
            styleguidePart({ title: 'Button secondary', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <button className="button--secondary">Button secondary</button>
                  )
                })
              )
            ),
            styleguidePart({ title: 'Button download', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <button className="button--download">Button download</button>
                  )
                })
              )
            )
          ])
        )
      ])
    ).run(_)
  )
})
